import * as React from 'react';
import * as util from "../../utils/util";
import {useNavigate} from 'react-router-dom';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import OutputRoundedIcon from '@mui/icons-material/OutputRounded';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import {useEffect} from "react";
import api from "../../utils/api";



const MoreList = () => {
  const navigate = useNavigate();
  const [isLogin, setIsLogin] = React.useState(false);
  
  useEffect(() => {
    setIsLogin(util.strNull(window.localStorage.userCusID) !== '' ? true : false);
  }, []);
  
  function handleClickLoginOut(){
    if(util.strNull(window.localStorage.userCusID) !== ''){ // logout
      localStorage.clear();
      alert("로그아웃 되었습니다.");
      navigate('/');
    }else{  // move login page
      navigate('/login');
    }
  }
  
  function handleDeleteUser(){
    const userCusId = util.strNull(window.localStorage.userCusID);
    if(userCusId !== '') { // logout
      if(window.confirm('정말 탈퇴하시겠습니까?')){
        api.post(`app/api/v1/AP_001_005`, { id: userCusId, email: util.strNull(window.localStorage.userID) }).then(res => {
          if(res.data.message === 'SUCCESSS'){
            alert('정상적으로 탈퇴 처리되었습니다.\n이용해주셔서 감사합니다.');
            localStorage.clear();
            navigate('/');
          }else{
            alert('탈퇴 과정에서 오류가 발생하였습니다.\n고객센터에 문의해주세요.');
          }
        }).catch(function (error) {
          console.log(error)
        });
      }
    }
  }

  const rightNavi = {
    p: '5px',

  }
  const rightNaviTitle = {
    p: 1,
    pb: 0,
    fontSize: 16,
    color: '#EF8322',
    fontWeight: 700,
    '&:hover': { bgcolor: 'transparent' }
  }
  const rightNaviMenu = {
    p: '10px 0 10px 0',
    fontSize: 14,
    fontWeight: 500,
    ml: '15px',
    '&:hover': { bgcolor: 'transparent' },
    '&:last-child': { pb: 1 }
  }
  const rightNaviout = {
    p: 1,
    fontSize: 16,
    color: '#555',
    fontWeight: 700,
    '&:hover': { bgcolor: 'transparent' },
    '&:last-child': { pb: 1 }
  }
  const RightNaviBtn = {
    border: 'none',
    p: 1,
    fontSize: 14,
    color: '#333'
  }

  
  
  return (
    <Box>
      <List disablePadding sx={rightNavi} className="rightNavi">
        <ListItem disablePadding >
          <Typography sx={rightNaviTitle} className="rightNaviTitle">
            병원예약
          </Typography>
        </ListItem>
      </List>
      <List disablePadding sx={rightNavi}>
        <ListItem disablePadding>
          <ListItemButton sx={rightNaviMenu} onClick={() => {
              {isLogin ? navigate('../reservation'): navigate('../Login')}
            }}>
            건강검진 예약
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding>
          <ListItemButton sx={rightNaviMenu} onClick={() => {
              {isLogin ? navigate('../Mypage/ReservationView'): navigate('../Login')}
            }}>
            예약정보 확인
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding>
          <ListItemButton sx={rightNaviMenu} onClick={() => {
              {isLogin ? navigate('../Mypage/ReservationView'): navigate('../Login')}
            }}>
            건강검진 결과
          </ListItemButton>
        </ListItem>
      </List>
      <Divider />

      <List disablePadding sx={rightNavi}>
        <ListItem disablePadding>
          <Typography sx={rightNaviTitle}>
            건강 체크
          </Typography>
        </ListItem>
      </List>
      <List disablePadding sx={rightNavi}>
        <ListItem disablePadding >
          <ListItemButton sx={rightNaviMenu}
           onClick={() => {
            navigate('../check/SelfCheckList');
          }}
          >
            자가진단
          </ListItemButton>
        </ListItem>
       <ListItem disablePadding >
          <ListItemButton sx={rightNaviMenu}
          onClick={() => {
            navigate('../check/Counsel');
          }}
          >
            상담하기
          </ListItemButton>
        </ListItem> 

      </List>
      <Divider />

      <List disablePadding sx={rightNavi}>
        <ListItem disablePadding >
          <Typography sx={rightNaviTitle}>
            맞춤 케어
          </Typography>
        </ListItem>
      </List>
      <List disablePadding sx={rightNavi}>
        <ListItem disablePadding >
          <ListItemButton sx={rightNaviMenu} onClick={() => {
              {isLogin ? navigate('../care'): navigate('../Login')}
            }}>
            맞춤 플랜
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding>
          <ListItemButton sx={rightNaviMenu}
          onClick={() => {
            navigate('../News/HealthNews');
          }}
          >
            건강 뉴스
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding>
          <ListItemButton sx={rightNaviMenu}>
            <a href="https://m.blog.naver.com/dualhealth_official" title="webzine" target='_blank' style={{textDecoration:'none', color:'#000'}}>웹진(블로그) </a>
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding >
          <ListItemButton sx={rightNaviMenu}>
            <a href="https://www.instagram.com/dualhealth_official/" title="instagram" target='_blank' style={{textDecoration:'none', color:'#000'}}>인스타그램 </a>
          </ListItemButton>
        </ListItem>
      </List>
      <Divider />

      <List disablePadding sx={rightNavi}>
        <ListItem disablePadding >
          <Typography sx={rightNaviTitle}>
            생활습관기록
          </Typography>
        </ListItem>
      </List>
      <List disablePadding sx={rightNavi}>
        <ListItem disablePadding >
          <ListItemButton sx={rightNaviMenu} onClick={() => {
              {isLogin ? navigate('../history'): navigate('../Login')}
            }}>
            기록하기
          </ListItemButton>
        </ListItem>
      </List>
      <Divider />

      <List disablePadding sx={rightNavi}>
        <ListItem disablePadding >
          <Typography sx={rightNaviTitle}>
            공지사항
          </Typography>
        </ListItem>
      </List>
      <List disablePadding sx={rightNavi}>
        <ListItem disablePadding >
          <ListItemButton sx={rightNaviMenu}
           onClick={() => {
              {isLogin ? navigate('../Notice/Notice'): navigate('../Login')}
            }}
          >
            공지사항
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding >
          <ListItemButton sx={rightNaviMenu}
          onClick={() => {
            navigate('../Notice/Support');
          }}
          >
            고객센터
          </ListItemButton>
        </ListItem>
      </List>
      <Divider />

      <List disablePadding sx={rightNavi}>
        <ListItem disablePadding >
          <Typography sx={rightNaviTitle}>
            약관 및 정책
          </Typography>
        </ListItem>
      </List>
      <List disablePadding sx={rightNavi}>
        <ListItem disablePadding >
          <ListItemButton sx={rightNaviMenu}
            onClick={() => {
              navigate('../Policy/Terms');
            }}
          >
            서비스 이용약관
          </ListItemButton>

        </ListItem>

        <ListItem disablePadding >
          <ListItemButton sx={rightNaviMenu}
            onClick={() => {
              navigate('../Policy/Private');
            }}
          >
            개인정보 처리방침
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding >
          <ListItemButton sx={rightNaviMenu}
            onClick={() => {
              navigate('../Policy/UsePolicy');
            }}
          >
            건강검진 이용 및 취소/환불 규정
          </ListItemButton>
        </ListItem>
      </List>
      <Divider />

      <List disablePadding sx={rightNavi}>
        <ListItem disablePadding >
          <Typography sx={rightNaviTitle}>
            버전 및 개발
          </Typography>
        </ListItem>
      </List>
      <List disablePadding sx={rightNavi}>
        <ListItem disablePadding >
          <ListItemButton sx={rightNaviMenu}
           onClick={() => {
            navigate('../Version/Version');
          }}
          >
            버전 및 라이센스
          </ListItemButton>
        </ListItem>
      </List>
      <Divider />

      <List disablePadding sx={rightNavi}>
        <ListItem disablePadding >
          <Typography sx={rightNaviTitle}>
            마이페이지
          </Typography>
        </ListItem>
      </List>
      <List disablePadding sx={rightNavi}>
        <ListItem disablePadding >
          <ListItemButton sx={rightNaviMenu} onClick={() => {
              {isLogin ? navigate('../MyPage/MyPage'): navigate('../Login')}
            }}>
            내정보 수정
          </ListItemButton>
        </ListItem>
      </List>
      <Divider sx={{ mb: 2 }} />

      <List disablePadding sx={rightNavi}>
        <ListItem disablePadding onClick={handleClickLoginOut}>
          <ListItemButton sx={rightNaviout}>
            <OutputRoundedIcon sx={{ pr: 1 }} /> {isLogin ? '로그아웃': '로그인'}
          </ListItemButton>
        </ListItem>
      </List>

      <Divider sx={{ mt: 2 }} />

      <Stack direction="row" sx={{ p: 2, fontSize: 12, display: isLogin ? 'block': 'none' }}>
        <Stack sx={{ flex: 1 }}>
          <Typography sx={{ fontSize: 12 }} onClick={handleDeleteUser}>회원 탈퇴하기</Typography>
        </Stack>
      </Stack>
    </Box>
  );
}

export default MoreList;